import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { resolve, reject } from 'q';

import { environment } from "../../environments/environment";
import { encode } from 'punycode';
import { BehaviorSubject } from 'rxjs';
// import { AlertService } from './alert.service';

@Injectable()
export class EmployeesService {
    constructor(private http: HttpClient) { };
    private il = new BehaviorSubject<string>('');
    inventory = this.il.asObservable();

    public getDiseaseList() {
        const getDiseaseListObservable = new Observable(observer => {
            this.http.get(`${environment.API_HOST}/disease`)
            .subscribe(response => {
                observer.next(response);
            }, error => {
                observer.next(error.reason);
            })
        });
        return getDiseaseListObservable; 
    } // prifle end*/
    public getDiseaseOne(disease) {
        const getQuestionTypeOneObservable = new Observable(observer => {
            this.http.get(`${environment.API_HOST}/disease/${disease.id}`)
            .subscribe(response => {
                observer.next(response);
            }, error => {
                observer.next(error.reason);
            })
        });
        return getQuestionTypeOneObservable; 
    } // prifle end*/
    public updateDiseaseOne(disease){
        const updateDiseaseOneObservable = new Observable(observer => {
            this.http.put(`${environment.API_HOST}/disease/${disease.id}`,disease)
            .subscribe(response => {
                observer.next(response);
            }, error => {
                observer.error(error.reason);
            })
        });
        return updateDiseaseOneObservable;  
    }
    public deleteDiseaseOne(disease){
        const deleteDiseaseOneObservable = new Observable(observer => {
            this.http.delete(`${environment.API_HOST}/disease/${disease.id}`)
            .subscribe(response => {
                observer.next(response);
            }, error => {
                observer.error(error.reason);
            })
        });
        return deleteDiseaseOneObservable;  
    }
    public newDiseaseOne(disease){
        const newDiseaseOneObservable = new Observable(observer => {
            this.http.post(`${environment.API_HOST}/disease/`,disease)
            .subscribe(response => {
                observer.next(response);
            }, error => {
                observer.error(error.reason);
            })
        });
        return newDiseaseOneObservable;  
    }

    public getEmployeeList() {
        const getEmployeeListObservable = new Observable(observer => {
            this.http.get(`${environment.API_HOST}/employee/`)
            .subscribe(response => {
                observer.next(response);
            }, error => {
                observer.next(error.reason);
            })
        });
        return getEmployeeListObservable; 
    } // prifle end*/
    public getEmployeeOne(employee) {
        const getEmployeeOneObservable = new Observable(observer => {
            this.http.get(`${environment.API_HOST}/employee/${employee}`)
            .subscribe(response => {
                observer.next(response);
            }, error => {
                observer.next(error.reason);
            })
        });
        return getEmployeeOneObservable; 
    } // prifle end*/
    public updateEmployeeOne(employee){
        const updateEmployeeOneObservable = new Observable(observer => {
            this.http.put(`${environment.API_HOST}/employee/${employee.code}`,employee)
            .subscribe(response => {
                observer.next(response);
            }, error => {
                observer.error(error.reason);
            })
        });
        return updateEmployeeOneObservable;  
    }
    public deleteEmployeeOne(employee){
        const deleteEmployeeOneObservable = new Observable(observer => {
            this.http.delete(`${environment.API_HOST}/employee/${employee.code}`)
            .subscribe(response => {
                observer.next(response);
            }, error => {
                observer.error(error.reason);
            })
        });
        return deleteEmployeeOneObservable;  
    }
    public newEmployeeOne(employee){
        const newEmployeeOneObservable = new Observable(observer => {
            this.http.post(`${environment.API_HOST}/employee/`,employee)
            .subscribe(response => {
                observer.next(response);
            }, error => {
                observer.error(error.reason);
            })
        });
        return newEmployeeOneObservable;  
    }

} // class

// Mon Apr 15 2019 13:33:13 GMT-0600